export default __webpack_public_path__ + "static/preschool9-6293c9fa80e2a8aa179f8a2ac42d343a.jpg";